if (!(Object.setPrototypeOf || {}.__proto__)) {
    let getPrototypeOf = Object.getPrototypeOf;

    Object.getPrototypeOf = function (obj) {
        return obj.__proto__ || getPrototypeOf.call(Object, obj);
    };
}
